// extracted by mini-css-extract-plugin
export default {"productGallery":"iH-z","inQuickShop":"jH-z"};